import React from 'react';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
function DataCatalogSyncInnerTable(_a) {
    var columns = _a.columns, rows = _a.rows, renderCellContent = _a.renderCellContent;
    return (React.createElement(TableContainer, { component: Paper },
        React.createElement(Table, { size: "small", classes: { root: 'dataCatalogSync__innerTable' } },
            React.createElement(TableHead, null,
                React.createElement(TableRow, null, columns.map(function (rowKey) { return React.createElement(TableCell, { key: rowKey }, rowKey); }))),
            React.createElement(TableBody, null, rows
                .map(function (row) {
                return (React.createElement(TableRow, { key: row.id, classes: { root: "dataCatalogSync__innerRow" } }, columns.map(function (column) { return (React.createElement(TableCell, { key: column }, renderCellContent ? renderCellContent(column, row) : row[column])); })));
            })))));
}
export default DataCatalogSyncInnerTable;
//# sourceMappingURL=DataCatalogSyncInnerTable.js.map